import React, { useState, useCallback } from "react";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import MainContent from "./components/MainContent/MainContent";
import ChatInput from "./components/ChatInput/ChatInput";
import TermsOfService from "./components/TermsOfService/TermsOfService";
import { useSessionCleanup } from "./hooks/useSessionCleanup";

function App() {
  useSessionCleanup();
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(true);

  const handleTermsClick = () => {
    setTermsModalOpen(true);
  };

  const closeTermsModal = () => {
    setTermsModalOpen(false);
  };

  const handleScrollPosition = useCallback((atBottom: boolean) => {
    setIsAtBottom(atBottom);
  }, []);

  return (
    <div className="app">
      <Header />
      <MainContent onScrollPosition={handleScrollPosition} />
      <ChatInput hiddenOnMobile={!isAtBottom} />
      <Footer
        onTermsClick={handleTermsClick}
        hiddenOnMobile={!isAtBottom}
      />
      <TermsOfService
        open={termsModalOpen}
        onClose={closeTermsModal}
      />
    </div>
  );
}

export default App;
